import { useMutation, useQueryClient } from '@tanstack/react-query';

import { accountKeys } from '~teacher/hook/account';
import { teamsKeys } from '~teacher/hook/team/teamsKeys';

import { changeAccessLevel } from '../../../api/teams';

export function useChangeTeamAccessLevel() {
  const queryClient = useQueryClient();
  return useMutation(changeAccessLevel, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [teamsKeys.all, accountKeys.account],
      });

      return window.location.reload();
    },
  });
}
